import { SxProps, Theme } from '@mui/material/styles';

export const dashboardTablePaperSx: SxProps<Theme> = {
  width: '100%',
  mb: 2,
  mt: 2,
};
